import Seo from "../components/Seo";

const SECTIONS = [
  {
    h: "Who we are",
    p: [
      "HiredToday is a UK job board operated by Centego Logistics Ltd, registered in England & Wales. Throughout these terms, \"we\", \"us\" and \"the site\" mean HiredToday, and \"you\" means the person or company using it.",
      "By creating an account or using the site you agree to these terms. If you don't agree, please don't use the site.",
    ],
  },
  {
    h: "What HiredToday does",
    p: [
      "We provide a place for employers to advertise genuine UK vacancies and for jobseekers to find and apply for them. We are not an employment agency and we are not a party to any contract between an employer and a jobseeker. Hiring decisions, interviews, offers, pay and working conditions are entirely matters between the employer and the jobseeker.",
    ],
  },
  {
    h: "Listing content standards",
    p: [
      "Every job listing is checked automatically before it can be submitted, and again by our team before it goes live. Listings must not contain phone numbers, email addresses or external links. Candidates apply through HiredToday so both sides stay protected.",
      "Listings must never charge applicants any fee (registration, administration, training, deposit or similar), charging jobseekers is unlawful under the Employment Agencies Act 1973 and the Conduct of Employment Agencies and Employment Businesses Regulations 2003.",
      "Listings must not favour or exclude anyone because of age, sex, race, nationality, religion, disability, sexual orientation, pregnancy, marriage or gender reassignment (the protected characteristics in the Equality Act 2010). This includes gendered job titles and \"native speakers only\" style wording. Genuine occupational requirements permitted by law are fine.",
      "Offensive, racist or abusive language is never acceptable. Listings that break these rules are rejected; repeated breaches can lead to account suspension and, where the law requires, referral to the relevant authorities.",
    ],
  },
  {
    h: "Jobseeker accounts",
    p: [
      "Jobseeker accounts are free. You must be at least 16 years old, provide accurate information, and keep your login details to yourself. When you apply for a job, the details you submit (name, email, phone, cover note and any CV link) are shared with that employer so they can respond to you.",
      "Please don't apply to roles you have no genuine interest in, and don't use the site to harvest employer details.",
    ],
  },
  {
    h: "Employer accounts and job postings",
    p: [
      "Employers may post jobs under one of three listings: Free, Standard or Featured, with an optional Urgent label on any plan. Current prices are on the pricing page and include VAT where applicable. Each listing covers a single job. Free listings are live for 7 days from approval; paid listings for 30 days.",
      "We may edit, reject or remove any listing at our discretion. For example if it is misleading, discriminatory, unlawful, a duplicate, or not a genuine vacancy. If we reject a paid listing before it goes live, the payment is refunded in full.",
      "By posting a job you confirm that: the vacancy is genuine; you have the right to advertise it; the content is accurate and complies with UK employment and equality law; and you will handle applicant data lawfully under UK GDPR.",
    ],
  },
  {
    h: "Verification and ID checks",
    p: [
      "To keep the board free of scams, every company must be verified by our team before its jobs can go live. During onboarding we ask for the company number, registered address, a director's name, and supporting documents such as the certificate of incorporation and proof of ownership. Jobseekers may also be asked to verify their identity (for example for driving roles).",
      "These documents are used only for verification. They are stored securely, treated as confidential, never shared with third parties, never shown publicly, and access is limited to the small team that reviews them. Verification data is handled under the privacy policy and deleted when no longer needed.",
      "Until verification is complete, an employer's jobs cannot go live. We may withdraw verification and remove listings if information turns out to be false or misleading.",
    ],
  },
  {
    h: "Payments and refunds",
    p: [
      "Payments are processed securely by Stripe. We never see or store your card details.",
      "Free listings are live for 7 days from approval; paid listings for 30 days. Refunds are given in full if we reject a paid listing before it goes live. Once a listing is live, the fee is non-refundable, but you may edit the listing at any point while it is live.",
    ],
  },
  {
    h: "What we don't allow",
    p: [
      "You must not post anything unlawful, misleading, discriminatory or offensive; scrape or copy the site; attempt to access another account; upload malicious code; or use the site for anything other than genuine recruitment and job seeking.",
      "We may suspend or close accounts that break these rules.",
    ],
  },
  {
    h: "Liability",
    p: [
      "We work hard to keep listings genuine, but we can't guarantee that every job or every applicant is exactly as described, and we're not responsible for the outcome of any application or hire. To the extent the law allows, our liability to you is limited to the amount you paid us in the 12 months before the claim.",
      "Nothing in these terms excludes liability for death or personal injury caused by negligence, fraud, or anything else that can't be excluded by law.",
    ],
  },
  {
    h: "Changes and contact",
    p: [
      "We may update these terms from time to time; the date above shows the current version. If a change is significant we'll flag it on the site.",
      "Questions about these terms: use the contact page and we'll reply.",
    ],
  },
];

export default function Terms() {
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20" data-testid="terms-page">
      <Seo
        title="Terms & Conditions | HiredToday"
        description="The terms of use for HiredToday, the UK job board operated by Centego Logistics Ltd."
        path="/terms"
      />
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">Legal</p>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-black text-zinc-950">Terms &amp; conditions</h1>
      <p className="mt-3 text-sm text-zinc-500">Last updated: August 2026</p>
      <div className="mt-10 space-y-10">
        {SECTIONS.map((s, i) => (
          <section key={s.h} data-testid={`terms-section-${i}`}>
            <h2 className="font-display text-xl font-bold text-zinc-950 mb-3">{i + 1}. {s.h}</h2>
            {s.p.map((para) => (
              <p key={para.slice(0, 40)} className="text-sm text-zinc-600 leading-relaxed mt-3">{para}</p>
            ))}
          </section>
        ))}
      </div>
    </main>
  );
}
